<template>
  <div>
    <ReverseMap />
    <br>
    <VMSSign />
    <br>
  </div>
</template>

<script>
import ReverseMap from '@/views/reverse/detail/ReverseMap.vue'
import VMSSign from '@/views/reverse/detail/ReverseSign.vue'

export default {
  components: {
    ReverseMap,
    VMSSign,
  },
  data() {
    return {
      check: false,
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

  <style>
  </style>
